// ═══ COUNTRY DIAL CODES (for Phone Number field) ══════════
// Each: iso, flag emoji, name, dial code, and expected national-number
// length(s). `len` is an array of acceptable digit counts (excluding code).
// Ported verbatim from legacy/EMR Forms.html, together with the pure phone
// parse/validate/format helpers (validatePhone, parsePhoneVal, fmtPhoneDisplay).

export const COUNTRIES = [
  {iso:'IN',flag:'🇮🇳',name:'India',dial:'91',len:[10]},
  {iso:'US',flag:'🇺🇸',name:'United States',dial:'1',len:[10]},
  {iso:'GB',flag:'🇬🇧',name:'United Kingdom',dial:'44',len:[10]},
  {iso:'CA',flag:'🇨🇦',name:'Canada',dial:'1',len:[10]},
  {iso:'AU',flag:'🇦🇺',name:'Australia',dial:'61',len:[9]},
  {iso:'AE',flag:'🇦🇪',name:'United Arab Emirates',dial:'971',len:[9]},
  {iso:'SG',flag:'🇸🇬',name:'Singapore',dial:'65',len:[8]},
  {iso:'DE',flag:'🇩🇪',name:'Germany',dial:'49',len:[10,11]},
  {iso:'FR',flag:'🇫🇷',name:'France',dial:'33',len:[9]},
  {iso:'IT',flag:'🇮🇹',name:'Italy',dial:'39',len:[9,10]},
  {iso:'ES',flag:'🇪🇸',name:'Spain',dial:'34',len:[9]},
  {iso:'NL',flag:'🇳🇱',name:'Netherlands',dial:'31',len:[9]},
  {iso:'CN',flag:'🇨🇳',name:'China',dial:'86',len:[11]},
  {iso:'JP',flag:'🇯🇵',name:'Japan',dial:'81',len:[10]},
  {iso:'KR',flag:'🇰🇷',name:'South Korea',dial:'82',len:[9,10]},
  {iso:'BR',flag:'🇧🇷',name:'Brazil',dial:'55',len:[10,11]},
  {iso:'MX',flag:'🇲🇽',name:'Mexico',dial:'52',len:[10]},
  {iso:'RU',flag:'🇷🇺',name:'Russia',dial:'7',len:[10]},
  {iso:'ZA',flag:'🇿🇦',name:'South Africa',dial:'27',len:[9]},
  {iso:'NG',flag:'🇳🇬',name:'Nigeria',dial:'234',len:[10]},
  {iso:'KE',flag:'🇰🇪',name:'Kenya',dial:'254',len:[9]},
  {iso:'EG',flag:'🇪🇬',name:'Egypt',dial:'20',len:[10]},
  {iso:'SA',flag:'🇸🇦',name:'Saudi Arabia',dial:'966',len:[9]},
  {iso:'PK',flag:'🇵🇰',name:'Pakistan',dial:'92',len:[10]},
  {iso:'BD',flag:'🇧🇩',name:'Bangladesh',dial:'880',len:[10]},
  {iso:'LK',flag:'🇱🇰',name:'Sri Lanka',dial:'94',len:[9]},
  {iso:'NP',flag:'🇳🇵',name:'Nepal',dial:'977',len:[10]},
  {iso:'ID',flag:'🇮🇩',name:'Indonesia',dial:'62',len:[9,10,11]},
  {iso:'MY',flag:'🇲🇾',name:'Malaysia',dial:'60',len:[9,10]},
  {iso:'PH',flag:'🇵🇭',name:'Philippines',dial:'63',len:[10]},
  {iso:'TH',flag:'🇹🇭',name:'Thailand',dial:'66',len:[9]},
  {iso:'VN',flag:'🇻🇳',name:'Vietnam',dial:'84',len:[9,10]},
  {iso:'TR',flag:'🇹🇷',name:'Turkey',dial:'90',len:[10]},
  {iso:'NZ',flag:'🇳🇿',name:'New Zealand',dial:'64',len:[8,9,10]},
  {iso:'IE',flag:'🇮🇪',name:'Ireland',dial:'353',len:[9]},
  {iso:'CH',flag:'🇨🇭',name:'Switzerland',dial:'41',len:[9]},
  {iso:'SE',flag:'🇸🇪',name:'Sweden',dial:'46',len:[7,8,9]},
  {iso:'PL',flag:'🇵🇱',name:'Poland',dial:'48',len:[9]}
];

export function countryByIso(iso: string): any {
  return COUNTRIES.find(c => c.iso === iso) || COUNTRIES[0];
}

// Validate a national phone number for a country; returns {ok, msg}.
export function validatePhone(iso: string, national: any): { ok: boolean; msg: string } {
  const c = countryByIso(iso);
  const digits = String(national || '').replace(/\D/g, '');
  if (!digits) return { ok: false, msg: 'Enter a phone number.' };
  if (!/^\d+$/.test(digits)) return { ok: false, msg: 'Only digits are allowed.' };
  if (!c.len.includes(digits.length)) {
    const exp = c.len.join(' or ');
    return { ok: false, msg: 'Invalid number for ' + c.name + ' — expected ' + exp + ' digits, got ' + digits.length + '.' };
  }
  return { ok: true, msg: '' };
}

// Parse a stored phone value (JSON string or object) into {iso,dial,national}.
export function parsePhoneVal(val: any): { iso: string; dial: string; national: string } {
  if (!val) return { iso: 'IN', dial: '91', national: '' };
  try { const o = typeof val === 'object' ? val : JSON.parse(val); return { iso: o.iso || 'IN', dial: o.dial || '', national: o.national || '' }; }
  catch { return { iso: 'IN', dial: '', national: String(val).replace(/\D/g, '') }; }
}

// Pretty-print a stored phone value, e.g. "🇮🇳 +91 9876543210".
export function fmtPhoneDisplay(val: any): string {
  const p = parsePhoneVal(val); if (!p.national) return '';
  const c = countryByIso(p.iso);
  return c.flag + ' +' + (p.dial || c.dial) + ' ' + p.national;
}
